import { MFieldName } from '../../../types/MandatoryFields';

export const squareVerifyBuyerModalPath: string =
  'assets/pages/square-verify-buyer.html';
export const squareVerifyBuyerModalName = 'square-verify-buyer';

export const squareContactFields: MFieldName[] = [
  'firstName',
  'lastName',
  'email',
  'city',
  'state',
  'phone',
  'countryCode',
  'zipCode',
  'address',
];

export const requiredSquareMFieldsToVerifyBuyer: MFieldName[] = [
  'firstName',
  'lastName',
];

export const squareVerifyBuyerModalConfig = {
  verificationDisplayedMaxTimeout: 10000,
};
